import * as userStorageService from '../services/user-storage-service';

const STORAGE_KEY = 'teamchat';

export const fetchTeamChatConfig = () => {
    const config = userStorageService.get(STORAGE_KEY); 
    if (config &&
        config.locationHref &&
        !config.widget &&
        config.activeConversations &&
        config.activeConversations.length === 1 &&
        config.locationHref !== window.location.href
    ) {
        config.activeConversations = [];
    }

    return config;
}

export const activateConversation = conversationId => {
    const config = userStorageService.get(STORAGE_KEY) || {};
    userStorageService.set(STORAGE_KEY, Object.assign({}, config, {
        activeConversations: config.widget ? [...(config.activeConversations || []).filter(cId => cId && cId.split('/')[0] !== conversationId), conversationId] : [conversationId],
        locationHref: config.widget ? null : window.location.href
    }));
}

export const deactivateConversation = conversationId => {
    const config = userStorageService.get(STORAGE_KEY) || {};
    userStorageService.set(STORAGE_KEY, Object.assign({}, config, {
        activeConversations: (config.activeConversations || []).filter(cId => cId && cId.split('/')[0] !== conversationId)
    }));
}

export const deactivateAllConversations = () => {
    const config = userStorageService.get(STORAGE_KEY) || {};
    userStorageService.set(STORAGE_KEY, Object.assign({}, config, {
        activeConversations: []
    }));
}

export const showNewConversation = newConversationInvitees => {
    const config = userStorageService.get(STORAGE_KEY) || {};
    userStorageService.set(STORAGE_KEY, Object.assign({}, config, {
        newConversationActive: true,
        newConversationInvitees,
        activeConversations: config.widget ? config.activeConversations : []
    }));
}

export const hideNewConversation = () => {
    const config = userStorageService.get(STORAGE_KEY) || {};
    userStorageService.set(STORAGE_KEY, Object.assign({}, config, {
        newConversationActive: false
    }));
}

export const enableWidget = () => {
    const config = userStorageService.get(STORAGE_KEY) || {};
    userStorageService.set(STORAGE_KEY, Object.assign({}, config, {
        widget: true,
        widgetOpen: true
    }));
}

export const disableWidget = () => {
    const config = userStorageService.get(STORAGE_KEY) || {};
    userStorageService.set(STORAGE_KEY, Object.assign({}, config, {
        widget: false,
        widgetOpen: false
    }));
}

export const openWidget = () => {
    const config = userStorageService.get(STORAGE_KEY) || {};
    userStorageService.set(STORAGE_KEY, Object.assign({}, config, {
        widgetOpen: true
    }));
}

export const closeWidget = () => {
    const config = userStorageService.get(STORAGE_KEY) || {};
    userStorageService.set(STORAGE_KEY, Object.assign({}, config, {
        widgetOpen: false
    }));
}
